<div class="card-header bg-light">
    <h3 class="card-title mb-0">
        <i *ngIf="this.id && !visualizar" class="fas fa-pencil-alt pr-2"></i>
        <i *ngIf="this.id && visualizar" class="fas fa-search pr-2"></i>
        <i *ngIf="!this.id" class="far fa-file pr-2"></i>
        {{ tituloModal }}
    </h3>
</div>

<div class="card-body wrapper">
  <form class="needs-validation" novalidate id="myForm" #f="ngForm">
    <div class="row mb-2">

      <div class="col-md-2 mb-2">
        <label for="inputIdentificador" class="mb-1">Identificador</label>
        <div class="input-group input-group-sm" style="width: 100%;">
          <input type="text" id="inputIdentificador" class="form-control form-control-sm" readonly
            [value]="model.identificador === 0 ? '-' : model.identificador" />
        </div>
      </div>

      <div class="col-md-5 mb-2">
        <label for="inputStatus" class="mb-1">Status</label>
        <div class="input-group input-group-sm" style="width: 100%;">
          <input type="text" id="inputStatus" class="form-control form-control-sm" readonly
            [value]="statusAtualDesc" />
        </div>
      </div>

      <div class="col-md-5 mb-2">
        <label for="inputnivelRelevancia" class="mb-1">Nível da Ação</label>
        <ng-select id="nivelRelevancia" [readonly]="visualizar" name="nivelRelevancia"
          [(ngModel)]="model.nivelRelevancia" [items]="nivelRelevanciaList" bindLabel="descricao"
          placeholder="Selecione um Nível de Relevância">
        </ng-select>
      </div>

      <div class="col-md-12 mb-2">
        <label for="inputTitulo" class="mb-1">Título da Ação</label>
        <div class="input-group input-group-sm" style="width: 100%;">
          <input type="text" id="inputTitulo" class="form-control form-control-sm" readonly
            [value]="model.titulo" />
        </div>
      </div>

      <div class="col-md-12 mb-2">
        <label for="inputDescricao" class="mb-1">Descrição da Ação</label>
        <div>
          <div class="form-control" [innerHTML]="model.descricao"
            style="min-height: 150px; max-height: 180px; overflow-y: auto; background-color: #e9ecef;">
          </div>
        </div>
      </div>

      <div class="col-md-8 mb-2">
        <label for="inputResponsavel" class="mb-1">Responsável</label>
        <div class="input-group input-group-sm" style="width: 100%;">
          <input type="text" id="inputResponsavel" class="form-control form-control-sm" readonly
            [value]="model.responsavelNome" />
        </div>
      </div>

      <div class="col-md-4 mb-2">
        <label class="form-label">Prazo de Implementação</label>
        <input type="text" class="form-control form-control-sm" placeholder="DD/MM/AAAA" bsDatepicker
          [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }" [(ngModel)]="model.prazo"
          [ngModelOptions]="{standalone: true}" [readonly]="visualizar || !podeEditarPrazo()" />
      </div>

      <div class="col-md-12 mb-2">
        <label class="mb-1">Recomendações</label>
        <div class="mat-elevation-z1">
          <table mat-table [dataSource]="dataSourceRecomendacao" matSortDisableClear matSort
            matSortDirection="asc">
            <tr mat-header-row *matHeaderRowDef="['titulo', 'actions']" class="bg-light">
            </tr>
            <ng-container matColumnDef="titulo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Recomendação
              </th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="!element?.recomendacao?.titulo">-</span>
                <span *ngIf="element?.recomendacao?.titulo">{{
                  element.recomendacao.titulo }}</span>
              </td>
            </ng-container>
            <ng-container cdkColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Ações
              </th>
              <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                <div class="d-flex justify-content-center align-items-center">
                  <button type="button" class="btn btn-info btn-xs ml-1" title="Visualizar"
                    (click)="modalRecomendacao(element)">
                    <i class="far fas fa-eye"></i>
                  </button>
                </div>
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: ['titulo', 'actions']"></tr>
          </table>
          <h5 class="table-no-data" [hidden]="dataSourceRecomendacao.data?.length > 0">
            Nenhuma recomendação vinculada
          </h5>
          <mat-paginator #tabelaRecomendacaoPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
            showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </div>

    <div class="secao-implementacao">Implementação e Avaliação da Ação</div>

    <mat-tab-group dynamicHeight (selectedIndexChange)="onAbaChange($event)">
      <mat-tab label="{{ numeroAbaAtiva }}ª Implementação e Avaliação">
        <div class="row mb-2 mt-2">
          <div class="col-md-12 mb-2">
            <label for="inputDescricaoImplementacao" class="mb-1">Descrição da Implementação da Ação</label>
            <div>
              <div class="form-control" [innerHTML]="model.descricaoImplementacao"
                style="min-height: 150px; max-height: 180px; overflow-y: auto; background-color: #e9ecef;">
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-2">
            <label for="inputPrazo" class="mb-1">Data da Realização</label>
            <div class="input-group input-group-sm" style="width: 100%;">
              <input type="text" id="inputDataRealizacao" class="form-control form-control-sm" readonly
                [value]="model.dataRealizacao ? (model.dataRealizacao | date:'dd/MM/yyyy') : '-'" />
            </div>
          </div>

          <div class="col-md-12 mb-2">
            <label class="mb-1">Evidências da Implementação da Ação</label>
            <div class="mat-elevation-z4">
              <table mat-table [dataSource]="dataSourceEvidencia" class="w-100" matSort matSortDisableClear>
                <tr mat-header-row *matHeaderRowDef="['arquivo', 'acoes']" class="bg-light"></tr>
                <ng-container matColumnDef="arquivo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivos</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.nome }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="acoes">
                  <th mat-header-cell *matHeaderCellDef>
                  </th>
                  <div class="w-100 d-flex justify-content-center">
                    <td mat-cell *matCellDef="let element; let i = index" class="block">
                      <div class="w-100 d-flex justify-content-center">
                        <button *ngIf="element.id !== 0" type="button" (click)="Download(element)"
                          class="btn btn-success btn-xs mr-1">
                          <i class="far fas fa-download"></i>
                        </button>
                      </div>
                    </td>
                  </div>
                </ng-container>
                <tr mat-row *matRowDef="let row; columns: ['arquivo', 'acoes']"></tr>
              </table>
              <h5 [hidden]="dataSourceEvidencia?.data?.length > 0" class="table-no-data">
                Nenhum registro encontrado
              </h5>
              <mat-paginator #tabelaEvidenciaPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>

          <div class="col-md-6 mb-2">
            <label for="inputStatusAvaliacao" class="mb-1">Avaliação da Implementação pelo Auditor</label>
            <ng-select id="status" [readonly]="visualizar" name="Status" [(ngModel)]="model.status"
              [items]="statusList" bindLabel="descricao" placeholder="Selecione um status">
            </ng-select>
          </div>

          <div class="col-md-12 mb-2">
            <label for="inputDescricaoAuditor" class="mb-1">Descrição da Avaliação da Implementação pelo
              Auditor</label>
            <div>
              <angular-editor *ngIf="!visualizar; else descricaoVisualizar" #maxLengthEditor
                [config]="editorConfig" (keydown)="onEditorKeyDown($event)"
                [(ngModel)]="model.descricaoImplementacaoAuditor" [ngModelOptions]="{standalone: true}">
              </angular-editor>
              <ng-template #descricaoVisualizar>
                <div class="form-control" [innerHTML]="model.descricaoImplementacaoAuditor"
                  style="min-height: 150px; max-height: 180px; overflow-y: auto;">
                </div>
              </ng-template>
            </div>
          </div>

          <div class="col-md-12 mt-2">
            <label class="mb-1">Evidências da Avaliação da Implementação pelo Auditor</label>
            <div class="mat-elevation-z4">
              <table mat-table [dataSource]="dataSourceEvidenciaAuditor" class="w-100" matSort
                matSortDisableClear>
                <tr mat-header-row *matHeaderRowDef="['arquivo', 'acoes']" class="bg-light"></tr>
                <ng-container matColumnDef="arquivo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivos</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.nome }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="acoes">
                  <th mat-header-cell *matHeaderCellDef class="text-right">
                    <span *ngIf="!visualizar">
                      <label for="file" class="btn btn-success btn-xs" style="margin-top: 10px"> Adicionar
                      </label>
                      <input type="file" id="file" name="file[]" multiple="multiple" style="display: none"
                        [accept]="acceptTypes" (change)="incluirEvidenciasAuditor($event)" />
                    </span>
                  </th>
                  <div class="w-100 d-flex justify-content-center">
                    <td mat-cell *matCellDef="let element; let i = index" class="block">
                      <div class="w-100 d-flex justify-content-center">
                        <button *ngIf="element.id !== 0" type="button"
                          (click)="DownloadAuditor(element)" class="btn btn-success btn-xs mr-1">
                          <i class="far fas fa-download"></i>
                        </button>
                        <button type="button" class="btn btn-danger btn-xs text-left"
                          (click)="excluirEvidenciaAuditor(i)" *ngIf="!visualizar">
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </div>
                </ng-container>
                <tr mat-row *matRowDef="let row; columns: ['arquivo', 'acoes']"></tr>
              </table>
              <h5 [hidden]="dataSourceEvidenciaAuditor?.data?.length > 0" class="table-no-data">
                Nenhum registro encontrado
              </h5>
              <mat-paginator #tabelaEvidenciaAuditorPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>

          <div class="col-md-6 mb-2">
            <label class="mb-1">Responsável da avaliação</label>
            <input type="text" class="form-control form-control-sm" readonly
              [value]="model.responsavelNomeMonitoramento || '-'" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="mb-1">Data e hora da avaliação</label>
            <input type="text" class="form-control form-control-sm" readonly
              [value]="model.dataMonitoramento ? (model.dataMonitoramento | date:'dd/MM/yyyy HH:mm') : '-'" />
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngFor="let h of historicosAnteriores" label="{{ h.numero }}ª Implementação e Avaliação">
        <ng-template matTabContent>
          <app-plano-acao-historico-ciclo [ciclo]="h" [identificador]="model.identificador" [somenteImplementacao]="true"></app-plano-acao-historico-ciclo>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>

<div class="card-footer">
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div class="list1">
      <button type="button" class="btn btn-default btn-sm mr-1" (click)="cancelar()" [hidden]="visualizar">
        <i class="fas fa-times"></i> Cancelar
      </button>
      <button type="button" class="btn btn-default btn-sm mr-1" (click)="fechar()" [hidden]="!visualizar">
        <i class="fas fa-times"></i> Fechar
      </button>
    </div>
    <div class="list2" *ngIf="!visualizar">
      <button type="button" class="btn btn-primary btn-sm mr-1" (click)="salvar()" [disabled]="indiceAba > 0">
        <i class="far fa-save"></i> Salvar
      </button>
    </div>
  </div>
</div>
